// extracted by mini-css-extract-plugin
module.exports = {"linkWrapper":"Breadcrumbs_linkWrapper__0Mf4j","crumb":"Breadcrumbs_crumb__45TGb"};